var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view not-found",style:({animation: !_vm.$loaded ? 'bottomElation 0.5s 1s both' : 'bottomElation 0.5s both'})},[_c('h1',{staticClass:"not-found-title"},[_vm._v("Strona nie istnieje!")])])}
var staticRenderFns = []

export { render, staticRenderFns }